import { use, useEffect, type RefObject } from "react";

import { NavigationContext } from "./use-navigation";

export function useKeyboardNavigation(
  containerRef: RefObject<HTMLElement | null>
) {
  const { nextPage, prevPage, page, totalPages } = use(NavigationContext)!;

  // Контейнер должен иметь фокус, чтобы keydown доходил до нашего обработчика.
  useEffect(() => {
    containerRef.current?.focus({ preventScroll: true });
  }, [containerRef]);

  useEffect(() => {
    const container = containerRef.current;
    if (container) {
      function handleKeyDown(e: KeyboardEvent) {
        // Инпуты (например, scrubber/range) сами обрабатывают стрелки.
        if (
          e.target instanceof HTMLInputElement ||
          e.target instanceof HTMLTextAreaElement ||
          e.target instanceof HTMLSelectElement
        ) {
          return;
        }

        // Space — нативный активатор для <button>, не перехватываем.
        if (e.key === " " && e.target instanceof HTMLButtonElement) {
          return;
        }

        // Локальный обработчик уже обработал событие.
        if (e.defaultPrevented) {
          return;
        }

        switch (e.key) {
          case "ArrowRight":
          case "ArrowDown":
          case " ":
            if (page < totalPages - 1) {
              e.preventDefault();
              nextPage();
            }
            break;
          case "ArrowLeft":
          case "ArrowUp":
            if (page > 0) {
              e.preventDefault();
              prevPage();
            }
            break;
        }
      }

      container.addEventListener("keydown", handleKeyDown);

      return () => {
        container.removeEventListener("keydown", handleKeyDown);
      };
    }
  }, [containerRef, nextPage, prevPage, page, totalPages]);
}
